/** student/portfolio — KEYS. */
export const studentPortfolioKeys = {
  all: () => ['student', 'portfolio'] as const,
};
